import { createFileRoute } from '@tanstack/react-router'
import { BillingSettingsPage } from '../components/billing-settings'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/de/einstellungen/abrechnung')({
  head: () => noIndexRouteHead('settingsBilling', 'de'),
  component: BillingSettingsPage,
})
